import get from 'lodash/get';
import * as searchActions from '../../action_creators/search/search_action_creators';
import SearchModel from '../../../models/search';
import log from '../../../services/logger_service';

export default function fetchSearchAction(params, store) {
  return function firstDispatch(dispatch) {
    dispatch(searchActions.searchLoading({}, store));

    const state = store.getState();
    let initialQueryParams = false;

    if (get(state, 'config.initialPageLoad')) {
      initialQueryParams = get(state, 'config.initialQueryParams.q');
    }

    const page =
      get(params, 'location.query.page') || get(params, 'params.page') || 1;
    const q = initialQueryParams || get(params, 'params.q') || false;

    return SearchModel.fetch({ q, page }, store)
      .then(function handleSearchModelData(searchData) {
        dispatch(searchActions.searchLoaded(searchData.data, store));
      })
      .catch(function handleSearchError(err) {
        dispatch(searchActions.searchError(err.data, q, store));
        log.error(err, `Error in search actions, message: ${err.message}`);
      });
  };
}
